/**
 * API Authentication URLs
 */
export const LOGIN_URL = 'auth/api-token-auth/'
export const JWT_CHECK_URL = 'auth/api-token-verify/'

/**
 * Projects URLs
 */
export const PROJECT_LIST_URL = 'projects/'

/**
 * Portfolio URLs
 */
export const PORTFOLIO_LIST_URL = 'portfolios/'
export const PORTFOLIO_CREATE_URL = 'portfolios/create/'



// WEBPACK FOOTER //
// ./src/router/paths.js